define('deepObject/get',['./util'], function( deepUtil ) {

    return function(obj, prop) {

		// @todo not a regexp guru -- can this be reduced to one expression?
		var props = deepUtil.getProps( prop ),
			i = 0,
			n, ret;

		n = props.length;
		while(typeof(obj = obj[props[i]]) !== 'undefined' && ++i < n) {}
		ret = obj;

		return ret;
	};
});
